import { BigNumber } from "@ethersproject/bignumber";

import moment from "moment";

export const formatDate = (dateMillis, format = "M-D-YY h:mma") =>
  moment(BigNumber.from(dateMillis).toNumber()).format(format);
